import React from 'react';
import { View, Image } from 'react-native-web';
import RenderHtml, { defaultHTMLElementModels, HTMLContentModel } from 'react-native-render-html';

export function ChatHtmlView({ item = {}, isInDetail = false, containerWidth = 500 }) {
    // region Local State
    const [itemHTMLHeight, setItemHTMLHeight] = React.useState(null);
    // endregion

    // region MAIN RENDER
    return(
        <View style={{ alignSelf: 'stretch', paddingTop: 12, maxHeight: isInDetail ? null : 150, overflow: 'hidden' }}>
            {/* Main HTML Renderer */}
            <View
                style={{ alignSelf: 'stretch' }}
                onLayout={(event) => !itemHTMLHeight && setItemHTMLHeight(event.nativeEvent.layout.height)}>
                <RenderHtml
                    contentWidth={containerWidth - 20}
                    source={{ html: !item.description.startsWith('<p>') ? item.description.replace(/(?:\r\n|\r|\n)/g, '<br>') : item.description }}
                    baseStyle={{ lineHeight: 26, fontSize: 16 }}
                    defaultTextProps={{ numberOfLines: isInDetail ? undefined : 5, allowFontScaling: false }}
                    enableExperimentalBRCollapsing={true}
                    enableExperimentalGhostLinesPrevention={true}
                    customHTMLElementModels={{
                        'label': defaultHTMLElementModels.label.extend({ contentModel: HTMLContentModel.block }),
                        'colgroup': defaultHTMLElementModels.colgroup.extend({ contentModel: HTMLContentModel.block }),
                        'col': defaultHTMLElementModels.col.extend({ contentModel: HTMLContentModel.block })
                    }}
                />
            </View>

            {/* Gradient */}
            {
                (!isInDetail && (itemHTMLHeight > 120)) &&
                <Image
                    source={require('../images/image_gradient.png')}
                    style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 20 }}
                />
            }
        </View>
    );
    // endregion
}
